/**
 * @module constants/Listener
 */

export const ListenerKeys = Object.freeze({
  // Do not change values. They map to API results
  BRANDING: 'branding',
  CONFIG: 'config',
  DAILY_SKIP_LIMIT: 'dailySkipLimit',
  STATION_SKIP_LIMIT: 'stationSkipLimit',
  INACTIVITY_TIMEOUT: 'inactivityTimeout',
  FLAGS: 'flags',
  SKIP_USAGE: 'skipUsage',
  EXPERIMENTS: 'experiments',
  IS_ANON: 'isAnonymous',
  LID: 'listenerId',
  PREMIUM_ELIGIBILITY: 'isEligibleForPremium',
  CURRENT_USER_ID_KEY: 'CURRENT_USER_ID',
  LISTENERS_KEY: 'LISTENERS',
  LAST_UPDATED_TIME: 'LAST_UPDATED_TIME',
  IS_FACEBOOK_TOKEN_VALID: 'IS_FACEBOOK_TOKEN_VALID',
} as const);

export const MAX_LISTENERS_TO_STORE = 5;

export const ListenerGenders = Object.freeze({
  GENDER_MALE: 'MALE',
  GENDER_FEMALE: 'FEMALE',
  GENDER_NOT_LISTED: 'NOT_LISTED',
  GENDER_NON_BINARY: 'NON_BINARY',
} as const);

export const ListenerActions = Object.freeze({
  SET_HAS_GIVEN_FEEDBACK: 'SET_HAS_GIVEN_FEEDBACK',
  LISTENER_AUTHENTICATED: 'LISTENER_AUTHENTICATED',
} as const);

export const AuthTypes = {
  CUSTOMER_SERVICE: 'customerService',
  ACCESS_TOKEN: 'accessToken',
  CACHED_LOGIN: 'cachedLogin',
  MANUAL_LOGIN: 'manualLogin',
  ANONYMOUS: 'anonymous',
  REGISTRATION: 'registration',
  RE_AUTH: 'reAuth',
  DEVICE_LOGIN: 'deviceLogin',
} as const;

export default ListenerActions;
